import '../style/dropdown-C4KH6HKf.css'
import { defineComponent as d, useModel as i, openBlock as p, createBlock as y, unref as l, mergeProps as f, isRef as g, withCtx as n, renderSlot as r, createCommentVNode as u } from "vue";
import c from "./popper.js";
const b = /* @__PURE__ */ d({
  name: "e-dropdown",
  __name: "dropdown",
  props: {
    open: { type: Boolean, default: !1 },
    placement: { default: "bottom-start" },
    transition: { default: "slide" },
    disabled: { type: Boolean, default: !1 },
    triggerByHover: { type: Boolean },
    toggleByClick: { type: Boolean, default: !0 },
    closeByContentClick: { type: Boolean, default: !1 },
    offsetDistance: { default: 6 },
    lazy: { type: Boolean, default: !0 },
    contentStyle: {},
    overlay: { type: [Boolean, Object] },
    renderTrigger: {}
  },
  setup(a) {
    const o = i(a, "open", { local: !0 });
    return (e, t) => (p(), y(l(c), f(e.$attrs, {
      modelValue: l(o),
      "onUpdate:modelValue": t[0] || (t[0] = (s) => g(o) ? o.value = s : null),
      placement: e.placement,
      variant: "dropdown",
      class: { "e-dropdown__disabled": e.disabled },
      transition: e.transition,
      "offset-distance": e.offsetDistance,
      "trigger-by-hover": e.triggerByHover,
      "toggle-by-click": e.toggleByClick,
      lazy: e.lazy,
      "auto-close": !e.closeByContentClick,
      "content-style": e.contentStyle,
      overlay: e.overlay,
      "render-trigger": e.renderTrigger
    }), {
      content: n(() => [
        r(e.$slots, "content")
      ]),
      default: n(() => [
        e.renderTrigger ? u("", !0) : r(e.$slots, "default", { key: 0 })
      ]),
      _: 3
    }, 16, ["modelValue", "placement", "class", "transition", "offset-distance", "trigger-by-hover", "toggle-by-click", "lazy", "auto-close", "content-style", "overlay", "render-trigger"]));
  }
});
export {
  b as default
};
//# sourceMappingURL=dropdown.js.map
